/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MonthAndYearSelector/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Dropdown from './Dropdown/index'
import React from 'react'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconChevronLeft from 'DesignSystem/Svgs/TysiaIconChevronLeft/index'
import TysiaIconChevronRight from 'DesignSystem/Svgs/TysiaIconChevronRight/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function MonthAndYearSelector({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthAndYearSelector"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let onClick1 = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="MonthAndYearSelector.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-ZQj9Ha': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-ZQj9Ha': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-ZQj9Ha': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-ZQj9Ha': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-ZQj9Ha': dtColorsNeutral100,'--bbc-6-ZQj9Ha': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
/>
<div
  data-testid="MonthAndYearSelector.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<button
  data-testid="MonthAndYearSelector.Vertical"
  data-view-path={viewPath}
 id="prev"
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
 type="primary"
>
{childProps => (
<TysiaIconChevronLeft
{...childProps}
  viewPath={`${viewPath}/TysiaIconChevronLeft`}
 width={dtSpaceM}
 height={dtSpaceM}
 fill={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
</button>
<button
  data-testid="MonthAndYearSelector.Vertical:1"
  data-view-path={viewPath}
 id="forward"
 {...isHoveredBind}
 onClick={onClick1}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
 type="primary"
>
{childProps => (
<TysiaIconChevronRight
{...childProps}
  viewPath={`${viewPath}/TysiaIconChevronRight`}
 width={dtSpaceM}
 height={dtSpaceM}
 fill={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
</button>
</div>
</div>
{children}
</React.Fragment>)
}